import { headers } from "../../../App/Axios"
import HTTPService from "../../../App/HTTPService"
import { User } from "../../../Types/User"

export const updateUserTutorialProgressRequest = (user: User, data: { tutorial_progress: number }) => {
    return HTTPService.patch(`/user/${user.id}/profile/`, data, headers)
}